const childrenAlunoDashboard = [
      {
        path: '',
        loadComponent: () => import('../pages/dashboard/dashboard').then(m => m.Dashboard)
      },
      {
        path: 'meus-dados',
        loadComponent: () => import('../pages/meus-dados/meus-dados').then(m => m.MeusDados)
      },
      {
        path: 'documentos',
        loadComponent: () => import('../pages/documentos/documentos').then(m => m.Documentos)
      },
      {
        path: 'ficha-inscricao',
        loadComponent: () => import('../pages/ficha-inscricao/ficha-inscricao').then(m => m.FichaInscricao)
      },
      {
        path: 'historico',
        loadComponent: () => import('../pages/historico/historico').then(m => m.Historico)
      },
      {
        path: 'declaracao-curso',
        loadComponent: () => import('../pages/declaracao-curso/declaracao-curso').then(m => m.DeclaracaoCurso)
      },
      {
        path: 'certificados',
        loadComponent: () => import('../pages/certificados/certificados').then(m => m.Certificados)
      },
      {
        path: 'segunda-via-certificado',
        loadComponent: () => import('../pages/dashboard/segunda-via-certificado/segunda-via-certificado').then(m => m.SegundaViaCertificado)
      },
      {
        path: 'pagamentos',
        loadComponent: () => import('../pages/pagamentos/pagamentos').then(m => m.Pagamentos)
      },
      {
        path: 'banco-talentos',
        loadComponent: () => import('../pages/dashboard/banco-talentos/banco-talentos').then(m => m.BancoTalentos)
      },
      {
        path: 'avaliacao-cursos',
        loadComponent: () => import('../pages/avaliacao-cursos/avaliacao-cursos').then(m => m.AvaliacaoCursos)
      },
      {
        path: 'identidade-estudantil',
        loadComponent: () => import('../pages/dashboard/identidade-estudantil/identidade-estudantil').then(m => m.IdentidadeEstudantil)
      },
      {
        path: 'solicitar-identidade',
        loadComponent: () => import('../pages/dashboard/solicitar-identidade/solicitar-identidade').then(m => m.SolicitarIdentidade)
      },
      {
        path: 'cadastro-curriculo',
        loadComponent: () => import('../pages/dashboard/cadastro-curriculo/cadastro-curriculo').then(m => m.CadastroCurriculo)
      },
      {
        path: 'termo-banco-talentos',
        loadComponent: () => import('../pages/dashboard/termo-banco-talentos/termo-banco-talentos').then(m => m.TermoBancoTalentos)
      },
      {
        path: 'wifi-servicos-unicamp',
        loadComponent: () => import('../pages/wifi-servicos-unicamp/wifi-servicos-unicamp').then(m => m.WifiServicosUnicamp)
      },
      {
        path: 'assinar',
        loadComponent: () => import('../pages/dashboard/widget-assinaturas-dashboard/widget-assinaturas-dashboard').then(m => m.WidgetAssinaturasDashboard)
      },
      {
        path: 'aceita-termos',
        loadComponent: () => import('../pages/dashboard/aceita-termo-dashboard/aceita-termo-dashboard').then(m => m.AceitaTermoDashboard)
      }
];

export default childrenAlunoDashboard;
